// Public card details from the organizer's Canva, checked on 22 September 2026.
// Keep the same nickname/profession scope as the original roster posters.
// Portraits 3, 4, 18, 27 and 89 were replaced with user-supplied photos on 23 September 2026.
// Portraits 29 and 55 use user-supplied photos from 24 September 2026.
// The user corrected the red-jacket photo from 35 to 55; 35 restores her original poster portrait.
// Contestant 27's number/nickname was checked against the full name on Canva page 14.
// Contestant 91 was verified on Canva page 46 on 23 September 2026.
// Its portrait was updated from Canva on 24 September, retaining Canva's visible crop.
// Record 92 was added separately on September 24 after explicit user confirmation; 74 stays unchanged.
// The later September 24 Canva refresh replaces portrait 11 and adds records 93–96.
// On September 25, portrait 11 uses the higher-resolution original supplied by the user.
// Final September 25 verification of Canva page 28 corrects 55's given name to เต็มเดือน.
// On September 25, the user supplied contestant 3's English role/company wording.
// Canva page 49 supplies 97 (Lin) and 98 (Arm), including their verified portraits.
export type PortraitCrop = { x: number; y: number; width: number; height: number; sourceWidth: number; sourceHeight: number }
export type ContestantUpdate = {
  number: number
  name: string
  profession: string
  photo: string | null
  photoPosition?: string
  photoCrop?: PortraitCrop
}

const details: [number: number, name: string, profession: string][] = [
  [1, 'น้ำแป้ง', 'พยาบาลวิชาชีพ'],
  [3, 'เก่ง', 'CEO\nPARADISE DECOR COMPANY LIMITED'],
  [4, 'ทราย', 'Senior Concept'],
  [7, 'พลอย', 'Content Creator'],
  [11, 'เอ๋', 'ที่ปรึกษาการเงิน ตัวแทนประกันชีวิต'],
  [16, 'นิด', 'ที่ปรึกษาการเงินและประกันชีวิต เจ้าของกิจการ · นายหน้าอสังหาฯ'],
  [18, 'แจน', 'ธุรกิจส่วนตัว'],
  [23, 'Buddy', 'Founder @Nasaran corporation'],
  [27, 'นิ', 'อิสระ'],
  [29, 'ว.', 'ตัวแทนประกันชีวิต บริษัท เอไอเอ'],
  [35, 'ยุ้ย อภิญญา', 'เจ้าของกิจการ'],
  [37, 'น้อย', 'กรรมการผู้จัดการ บริษัท 3คูณ การช่าง, BD บริษัท สตรองเทค'],
  [38, 'เจสสิก้า', 'คุณครู'],
  [39, 'เปิ้ล', 'ค้าขาย'],
  [40, 'ยุ้ย', 'Deputy Leasing Director'],
  [41, 'จูน', 'ครูสอนร้องเพลง'],
  [42, 'เยลลี่', 'แอร์โฮสเตส, อินฟลู, นางแบบ'],
  [43, 'อิ๋ว', 'ผู้อำนวยการ'],
  [44, 'น้อง', 'ธุรกิจการท่องเที่ยว ธุรกิจสปา'],
  [45, 'ทราย', 'พนักงานบริษัท'],
  [46, 'ติ๊นา', 'กรรมการผู้จัดการ บริษัท พลาซ่า เรดิโอ สื่อโฆษณา จำกัด'],
  [47, 'Miko', 'ธุรกิจส่วนตัว'],
  [48, 'ฝอฝน', 'Freelance อินฟลู'],
  [49, 'Apat (เอพัท)', 'Marketing Manager'],
  [50, 'Anne', 'Senior Marketing Manager'],
  [51, 'ปลา', 'เจ้าของแบรนด์มาดามปลา ซัพพอร์ต บราและชุดกระชับ'],
  [52, 'นานา', 'ธุรกิจส่วนตัว'],
  [53, 'ป้อม', 'ธุรกิจส่วนตัว รับจ้างทั่วไป'],
  [54, 'แพรว', 'จัดหาสินค้าพรีเมี่ยม'],
  [55, 'ยุ้ย เต็มเดือน', 'ธุรกิจด้านการซื้อขายอสังหาริมทรัพย์'],
  [56, 'แพนเค้ก', 'โครงการพัฒนาและส่งเสริมสุขภาพในสถานประกอบการ เครือข่ายสภาอุตสาหกรรมแห่งประเทศไทย'],
  [57, 'ย้ง', 'ค้าขายออนไลน์'],
  [58, 'นุ้ย', 'พนักงานบัญชี'],
  [59, 'แป้ง', 'ฟรีแลนซ์'],
  [60, 'Janny', 'เจ้าของธุรกิจ WinkClinic / นำเข้า จำหน่าย skincare จากเกาหลี'],
  [61, 'ของขวัญ', 'นางแบบ Influencer รีวิว ร่วมงานพรมแดง เปิดตัวแบรนด์สาขาใหม่หรืองานอื่นๆ'],
  [62, 'หมัน', 'ธุรกิจส่วนตัว'],
  [63, 'น้ำส้ม', 'ทนายความ'],
  [64, 'ชาช่า', 'พิธีกร th-eng / ผู้ประกาศ / เจ้าของออแกไนเซอร์'],
  [65, 'วรรณ', 'แม่บ้าน'],
  [66, 'สน', 'เกษียณ แม่บ้าน'],
  [67, 'Ying', 'Employee'],
  [68, 'maishury', 'logistics manager'],
  [69, 'เก๋', 'ธุรกิจส่วนตัว: character design, ebook publisher, retail collectible books and toys'],
  [70, 'เพียว', 'Influencer และนักแสดงอิสระ'],
  [71, 'ฐา', 'อาสาสมัครสาธารณสุขประจำหมู่บ้าน'],
  [72, 'แหน', 'ช่างผม ช่างผ้า'],
  [73, 'กุ๊กกิ๊ก', 'เจ้าหน้าที่ฝ่ายจัดซื้อ'],
  [74, 'เก๋', 'นักลงทุน และผู้บริหาร เนรัญชรา ฟิตเนส แอนด์ สปา'],
  [75, 'แพร์', 'ผลิตภัณฑ์เสริมอาหาร Usana สกินแคร์ Celavive'],
  [76, 'เหมยลี่', ''],
  [77, 'Spy', "เจ้าของธุรกิจและแบรนด์ O'VIRA เสื้อผ้า Wellness Lifestyles"],
  [78, 'ซันญ่า', 'ดูแลคุณแม่อยู่บ้าน'],
  [79, 'เอ่เอ๊', 'ธุรกิจส่วนตัว'],
  [80, 'Bonus', 'Health Consultant'],
  [81, 'น้ำตาล', 'ครูสอนโยคะ'],
  [82, 'จุ๋ม', 'พนักงานบริษัท (CEO)'],
  [83, 'อุ้ม', 'ราชการ'],
  [84, 'ป๊อบ', 'ทนายความ ที่ปรึกษากฎหมาย'],
  [85, 'ก้อยก้อย', 'พนักงานบริษัท'],
  [86, 'เบ', 'Casting Director'],
  [87, 'ตุ๊กตา', 'ที่ปรึกษาการลงทุนซื้อขายทองคำ'],
  [88, 'อุ๊', 'ธุรกิจส่วนตัว'],
  [89, 'ซาร่า', 'ธุรกิจส่วนตัว'],
  [90, 'หญิง', 'แม่บ้านเลี้ยงลูก'],
  [91, 'โอ๋', 'อาจารย์แพทย์'],
  [92, 'เก๋', 'ธุรกิจ Wellness · เนรัญชลา ฟิตเนส แอนด์ สปา'],
  [93, 'Pikky', 'ขายเครื่องสำอางเกาหลี ญี่ปุ่น ไต้หวัน'],
  [94, 'ฟ้า', 'ออร์แกไนซ์งานอีเวนต์และทัวร์'],
  [95, 'เมย์ นางฟ้า', 'ตัวแทนประกันชีวิต AIA'],
  [96, 'ROSE', 'Teacher'],
  [97, 'Lin', 'กิจการส่วนตัว'],
  [98, 'Arm', 'Business owner'],
]

const missingPhotos = new Set([79, 81])
const photoRevisions: Record<number, string> = { 3: '20260923', 4: '20260923', 11: '20260925', 18: '20260923', 27: '20260923', 29: '20260924', 55: '20260924', 84: '20260922', 89: '20260923', 91: '20260924', 92: '20260924', 93: '20260924', 94: '20260924', 95: '20260924', 96: '20260924' }
const photoSources: Record<number, string> = {
  35: '/images/contestants/poster-04-lossless.webp',
  97: '/images/contestants/contestant-97-20260925.jpg',
  98: '/images/contestants/contestant-98-20260925.png',
}
// CSS-only windows preserve source pixels: 35 restores her poster portrait, 55 frames the supplied photo.
const photoCrops: Record<number, PortraitCrop> = {
  11: { x: 0, y: 135, width: 960, height: 1571, sourceWidth: 960, sourceHeight: 1706 },
  35: { x: 770, y: 2176, width: 620, height: 520, sourceWidth: 2160, sourceHeight: 3240 },
  55: { x: 0, y: 140, width: 1108, height: 1337, sourceWidth: 1108, sourceHeight: 1477 },
  91: { x: 126, y: 42, width: 360, height: 461, sourceWidth: 580, sourceHeight: 545 },
  92: { x: 0, y: 0, width: 482, height: 724, sourceWidth: 482, sourceHeight: 724 },
  93: { x: 0, y: 30, width: 472, height: 592, sourceWidth: 472, sourceHeight: 622 },
  94: { x: 190, y: 475, width: 360, height: 600, sourceWidth: 663, sourceHeight: 1435 },
  95: { x: 160, y: 540, width: 380, height: 580, sourceWidth: 663, sourceHeight: 1434 },
  96: { x: 0, y: 0, width: 522, height: 520, sourceWidth: 522, sourceHeight: 520 },
  98: { x: 144, y: 253, width: 336, height: 431, sourceWidth: 533, sourceHeight: 800 },
}
const photoPositions: Record<number, string> = {
  1: 'center 25%',
  3: 'center top', 4: 'center 75%', 27: 'center 10%', 29: 'center top', 91: 'center top', 92: 'center top',
  23: 'center 48%', 38: '70% center', 39: 'center 48%', 40: 'center 20%', 45: '60% center',
  58: 'center 45%', 63: 'center 80%', 66: 'center 55%', 68: 'center 48%', 71: 'center 45%',
  72: 'center 55%', 78: 'center 50%', 80: 'center 60%', 84: 'center 20%', 87: 'center 65%',
  89: 'center 90%',
}

export const contestantUpdates: ContestantUpdate[] = details.map(([number, name, profession]) => ({
  number, name, profession,
  photo: missingPhotos.has(number) ? null : photoSources[number] ?? `/images/contestants/contestant-${String(number).padStart(2, '0')}${photoRevisions[number] ? `-${photoRevisions[number]}` : ''}.webp`,
  photoPosition: photoPositions[number],
  photoCrop: photoCrops[number],
}))
